<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

/*Custom javascript to smooth scrolling product thumbnails slider*/
document.addEventListener('DOMContentLoaded', function() {
    function checkSliderInitialized() {
        const sliderContainer = document.querySelector('.productView-thumbnail-wrapper .productView-for');
        if (sliderContainer && sliderContainer.classList.contains('slick-initialized')) {
            const slickList = sliderContainer.querySelector('.slick-list');
            if (slickList) {
                const thumbnailsContainer = slickList.querySelector('.slick-track');

                thumbnailsContainer.addEventListener('click', function(event) {
                    const thumbnail = event.target.closest('.productView-thumbnail');
                    if (thumbnail) {
                        const thumbnailIndex = parseInt(thumbnail.getAttribute('data-slick-index'));
                        const thumbnailOffsetTop = thumbnail.offsetTop;
                        const containerScrollTop = slickList.scrollTop;
                        const containerHeight = slickList.clientHeight;

                        if (thumbnailOffsetTop < containerScrollTop || thumbnailOffsetTop + thumbnail.clientHeight > containerScrollTop + containerHeight) {
                            slickList.scrollTo({
                                top: thumbnailOffsetTop,
                                behavior: 'smooth'
                            });
                        }
                    }
                });
            }

            clearInterval(checkInterval);
        }
    }

    const checkInterval = setInterval(checkSliderInitialized, 100);

    //Mostrare swatch del tema se il blocco dell'app è vuoto (DETTAGLIO PRODOTTO)
    const appBlock = document.querySelector('.shopify-app-block king-linked-options-product');
    const themeSwatch = document.querySelector('.productView-variants variant-radios .product-form__input.product-form__colore');
  
    if (appBlock && appBlock.innerHTML.trim() === '') {
      themeSwatch.style.display = 'block';
    }
});



<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->



